import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "auth";

export const login = async (payload: any) => {
	try {
		const endpoint = `${initialRoute}/login`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succAuth) {
				const {
					data: { result }
				} = response;
				const {
					data: { token }
				} = response;
				localStorage.setItem("@jwt", token);
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		console.log(error);
		alert(error);
		throw error;
	}
};
